(() => {
  const initWholesalePage = (root) => {
    if (!root || root.dataset.wholesaleModalReady === 'true') return;
    root.dataset.wholesaleModalReady = 'true';

    const modals = {
      capture: root.querySelector('[data-wholesale-modal="capture"]'),
      success: root.querySelector('[data-wholesale-modal="success"]')
    };
    const form = root.querySelector('[data-wholesale-form]');
    let activeModal = null;
    let returnFocus = null;

    const focusableSelector = 'a[href], button:not([disabled]), input:not([disabled]), [tabindex]:not([tabindex="-1"])';

    const closeModal = () => {
      if (!activeModal) return;
      activeModal.hidden = true;
      activeModal = null;
      document.body.classList.remove('bbj-wholesale-modal-open');
      if (returnFocus && document.contains(returnFocus)) returnFocus.focus();
    };

    const openModal = (name, trigger) => {
      const modal = modals[name];
      if (!modal) return;
      if (activeModal) activeModal.hidden = true;
      returnFocus = trigger || returnFocus;
      modal.hidden = false;
      activeModal = modal;
      document.body.classList.add('bbj-wholesale-modal-open');
      window.requestAnimationFrame(() => {
        const focusTarget = modal.querySelector(name === 'capture' ? 'input[type="email"]' : '.bbj-wholesale-modal__shop') || modal.querySelector(focusableSelector);
        if (focusTarget) focusTarget.focus();
      });
    };

    root.querySelectorAll('[data-wholesale-open="capture"]').forEach((trigger) => {
      trigger.addEventListener('click', () => openModal('capture', trigger));
    });

    root.querySelectorAll('[data-wholesale-close]').forEach((trigger) => {
      trigger.addEventListener('click', closeModal);
    });

    document.addEventListener('keydown', (event) => {
      if (!activeModal) return;
      if (event.key === 'Escape') closeModal();
      if (event.key !== 'Tab') return;
      const focusable = [...activeModal.querySelectorAll(focusableSelector)].filter((element) => !element.hidden);
      if (!focusable.length) return;
      const first = focusable[0];
      const last = focusable[focusable.length - 1];
      if (event.shiftKey && document.activeElement === first) {
        event.preventDefault();
        last.focus();
      } else if (!event.shiftKey && document.activeElement === last) {
        event.preventDefault();
        first.focus();
      }
    });

    if (form) {
      const submitButton = form.querySelector('[type="submit"]');
      const errorBox = form.querySelector('.bbj-wholesale-modal__errors');

      form.addEventListener('submit', async (event) => {
        event.preventDefault();
        if (!form.reportValidity()) return;

        submitButton.disabled = true;
        submitButton.textContent = 'Unlocking…';
        errorBox.textContent = '';

        try {
          const response = await fetch(form.action, {
            method: 'POST',
            body: new FormData(form),
            headers: { Accept: 'text/html' },
            credentials: 'same-origin'
          });
          const responseHtml = await response.text();
          const responseDocument = new DOMParser().parseFromString(responseHtml, 'text/html');
          const returnedErrors = responseDocument.querySelector('.bbj-wholesale-modal__errors');
          const hasReturnedErrors = Boolean(returnedErrors && returnedErrors.textContent.trim());
          const responseUrl = new URL(response.url, window.location.origin);
          const hasPostedFlag = responseUrl.searchParams.get('customer_posted') === 'true';
          const hasSuccessMarker = Boolean(responseDocument.querySelector('[data-wholesale-result="success"]'));
          const succeeded = !hasReturnedErrors && (hasSuccessMarker || hasPostedFlag);

          if (succeeded) {
            form.reset();
            openModal('success');
            return;
          }

          errorBox.innerHTML = returnedErrors && returnedErrors.innerHTML.trim()
            ? returnedErrors.innerHTML
            : 'We could not unlock your savings. Please check your email address and try again.';
        } catch (error) {
          errorBox.textContent = 'We could not unlock your savings. Please try again.';
        } finally {
          submitButton.disabled = false;
          submitButton.textContent = 'Unlock Savings';
        }
      });
    }

    const pageUrl = new URL(window.location.href);
    const pageHasPostedFlag = pageUrl.searchParams.get('customer_posted') === 'true';

    if (root.querySelector('[data-wholesale-result="success"]') || pageHasPostedFlag) {
      openModal('success');
      if (pageHasPostedFlag) {
        pageUrl.searchParams.delete('customer_posted');
        window.history.replaceState({}, '', `${pageUrl.pathname}${pageUrl.search}${pageUrl.hash}`);
      }
    } else if (form && form.querySelector('.bbj-wholesale-modal__errors').textContent.trim()) {
      openModal('capture');
    }
  };

  const initAll = (scope = document) => {
    scope.querySelectorAll('.bbj-wholesale-page').forEach(initWholesalePage);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initAll());
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', (event) => initAll(event.target));
})();
